import { cloneDeep } from 'lodash';

import { get, isArray, set } from 'lodash';
import { AUSGABE_KATEGORIE, KOSTEN_ARTEN, KOSTEN_POSITION } from '../../../../../lib/constants/constant';
import { addIndexesToPath, getFieldNamefromDataPath, groupKostenByPosition } from '../../../../../utils/helper';
import { calculateGesamtSumme, calculateProjektDauer, calculateProjektStartJahr } from '../commonFormulas';

// import schemas
import { getLocalstorageToken } from '../../../../../context/AuthHelper';
import AntragSchema from '../../../../../lib/paths/antrag_FULL_Paths.json';
import KostenPositionSchema from '../../../../../lib/paths/kostenposition_FULL_Paths.json';
const P = AntragSchema.attributes;
const KP_P = KostenPositionSchema.attributes;

export const executeEbusseAntragFormulas = (
	application: any,
	kostenKategories: any,
	vonTag: number,
	vonMonat: string,
	bisTag: number,
	bisMonat: string
) => {
	let appCopy = cloneDeep(application);
	let result: any[] = [];
	const kostenKategoriesGroup = groupKostenByPosition(kostenKategories);

	let calculatedProjektJahr = calculateProjektStartJahr(appCopy, vonTag, vonMonat);
	let calculatedProjektDauer = calculateProjektDauer(appCopy, vonTag, vonMonat, bisTag, bisMonat);
	if (isArray(calculatedProjektJahr)) {
		for (let ele of calculatedProjektJahr) {
			set(appCopy, get(ele, 'path'), get(ele, 'value'));
		}
	}
	if (isArray(calculatedProjektDauer)) {
		for (let ele of calculatedProjektDauer) {
			set(appCopy, get(ele, 'path'), get(ele, 'value'));
		}
	}
	result.push(...calculatedProjektJahr);
	result.push(...calculatedProjektDauer);

	if (get(appCopy, P.Allgemein_Projektdauerin_Jahren.path) > 0) {
		if (get(kostenKategoriesGroup, KOSTEN_POSITION.Ausgabe, []).includes(KOSTEN_ARTEN.Investitionskosten)) {
			let calculatedInvestitionsKosten = calculateInvestitionsKosten(appCopy, kostenKategories);
			if (isArray(calculatedInvestitionsKosten)) {
				for (let ele of calculatedInvestitionsKosten) {
					set(appCopy, get(ele, 'path'), get(ele, 'value'));
				}
			}
			result.push(...calculatedInvestitionsKosten);
		}
		if (get(kostenKategoriesGroup, KOSTEN_POSITION.Einnahme, []).includes(KOSTEN_ARTEN.Eigenmittel)) {
			let calculatedEinnahmen = calculateEinnahmen(appCopy);
			if (isArray(calculatedEinnahmen)) {
				for (let ele of calculatedEinnahmen) {
					set(appCopy, get(ele, 'path'), get(ele, 'value'));
				}
			}
			result.push(...calculatedEinnahmen);
		}
	}

	// Berechnet die Förderquote auf Jarhen aufgeteilt für Antragsteller und jede Partner
	let calculatedFoerderQuote = calculateFoerderquote(appCopy);
	result.push(...calculatedFoerderQuote);
	for (let ele of calculatedFoerderQuote) {
		set(appCopy, get(ele, 'path'), get(ele, 'value'));
	}

	// Berechnet die Jahrenaufteilung für Ausgaben, Einnahmen, Zuwendung und Förderquote
	let calculatedJahresaufteilung = calculateJahresAufteilung(appCopy);
	result.push(...calculatedJahresaufteilung);
	for (let ele of calculatedJahresaufteilung) {
		set(appCopy, get(ele, 'path'), get(ele, 'value'));
	}

	// Berechnet die Gesamt Förderquote für Antragsteller und jede Partner
	let calculatedGesamtFoerderquote = calculateGesamtFoerderquote(appCopy);
	result.push(...calculatedGesamtFoerderquote);
	for (let ele of calculatedGesamtFoerderquote) {
		set(appCopy, get(ele, 'path'), get(ele, 'value'));
	}

	let calculatedGesamtSummeSkizze = calculateGesamtSumme(appCopy);
	if (isArray(calculatedGesamtSummeSkizze)) {
		for (let ele of calculatedGesamtSummeSkizze) {
			set(appCopy, get(ele, 'path'), get(ele, 'value'));
		}
	}
	result.push(...calculatedGesamtSummeSkizze);

	return result;
};

function getKostenKategorieForInvestiv(valueFromDB: any, kostenKategories: any): string {
	if (typeof valueFromDB === 'object') {
		const givenKategor = kostenKategories.find((ele: any) => ele.id === valueFromDB.id);
		return get(givenKategor, 'attributes.Allgemein_Ausgabekategorie');
	} else {
		const givenKategor = kostenKategories.find((ele: any) => ele.id === valueFromDB);
		return get(givenKategor, 'attributes.Allgemein_Ausgabekategorie');
	}
}
function calculateInvestitionsKosten(application: any, kostenKategories: any) {
	let result: any[] = [];
	const allKostenPositions = get(application, P.Foerderantrag_Kostenpositions.path, []);

	for (let i = 0; i < allKostenPositions.length; i++) {
		const eachInvestitionsKosten = allKostenPositions[i];
		const ausgabeKategorie = getKostenKategorieForInvestiv(get(eachInvestitionsKosten, KP_P.Allgemein_Kostenkategorie.path), kostenKategories);

		if (get(eachInvestitionsKosten, KP_P.Allgemein_Kostenart_Finanzierung.path) === KOSTEN_ARTEN.Investitionskosten) {
			if (ausgabeKategorie === AUSGABE_KATEGORIE.Elektrofahrzeug) {
				const transformedData = transformInvestitionsKostenElektroBusse(
					eachInvestitionsKosten,
					get(application, P.Allgemein_Projektstart_Jahr.path),
					get(application, P.Allgemein_Projektdauerin_Jahren.path)
				);

				result.push({
					path: `${P.Foerderantrag_Kostenpositions.path}.${i}`,
					value: transformedData,
				});
			} else if (ausgabeKategorie === AUSGABE_KATEGORIE.LadeTankInfrastruktur) {
				const transformedData = transformInvestitionsKostenLadeInfrastruktur(
					eachInvestitionsKosten,
					get(application, P.Allgemein_Projektstart_Jahr.path),
					get(application, P.Allgemein_Projektdauerin_Jahren.path)
				);
				result.push({
					path: `${P.Foerderantrag_Kostenpositions.path}.${i}`,
					value: transformedData,
				});
			} else if (ausgabeKategorie === AUSGABE_KATEGORIE.NetzanschlussUndErdarbeiten) {
				const transformedData = transformInvestitionsKostenNetzanschluss(
					eachInvestitionsKosten,
					get(application, P.Allgemein_Projektstart_Jahr.path),
					get(application, P.Allgemein_Projektdauerin_Jahren.path)
				);
				result.push({
					path: `${P.Foerderantrag_Kostenpositions.path}.${i}`,
					value: transformedData,
				});
			} else if (ausgabeKategorie === AUSGABE_KATEGORIE.H2) {
				const transformedData = transformInvestitionsKostenH2(
					eachInvestitionsKosten,
					get(application, P.Allgemein_Projektstart_Jahr.path),
					get(application, P.Allgemein_Projektdauerin_Jahren.path)
				);
				result.push({
					path: `${P.Foerderantrag_Kostenpositions.path}.${i}`,
					value: transformedData,
				});
			}
		}
	}

	return result;
}
function calculateEinnahmen(application: any) {
	let result: any[] = [];

	const allKostenPositions = get(application, P.Foerderantrag_Kostenpositions.path, []);
	for (let i = 0; i < allKostenPositions.length; i++) {
		const eachEigenmittel = allKostenPositions[i];
		if (get(eachEigenmittel, KP_P.Allgemein_Kostenart_Finanzierung.path) === KOSTEN_ARTEN.Eigenmittel) {
			const allGemeinKostenProJahrBlock = get(eachEigenmittel, KP_P.Allgemein_Kosten_Pro_Jahr.path, []);
			const gesamtSumme = calculateAllgemeinKostenProJehrGesamtSumme(allGemeinKostenProJahrBlock);

			result.push(
				{
					path: addIndexesToPath(
						P.Foerderantrag_Kostenpositions.schema.attributes.Allgemein_Kosten_Pro_Jahr.path,
						[`${i}`],
						['Foerderantrag_Kostenpositions']
					),
					value: ensureArrayLength(
						allGemeinKostenProJahrBlock,
						get(application, P.Allgemein_Projektdauerin_Jahren.path),
						get(application, P.Allgemein_Projektstart_Jahr.path),
						{ Zelle_2: null }
					),
				},
				{
					path: addIndexesToPath(
						P.Foerderantrag_Kostenpositions.schema.attributes.Allgemein_Geplante_Gesamtsumme.path,
						[`${i}`],
						['Foerderantrag_Kostenpositions']
					),
					value: !isNaN(gesamtSumme) ? gesamtSumme : 0,
				}
			);
		}
	}
	return result;
}
function calculateFoerderquote(application: any) {
	let result: any = [];
	const allKostenPositionsARR = get(application, P.Foerderantrag_Kostenpositions.path, []);
	const AntragstellerId = get(application, `${P.Antragstellende_Organisation.path}.id`);
	const allKostenpositionVonAntragsteller = allKostenPositionsARR.filter((ele: any) => get(ele, `${KP_P.Unternehmen.path}.id`) === AntragstellerId);

	console.log(' allKostenpositionVonAntragsteller ', allKostenpositionVonAntragsteller);
	result.push({
		path: P.Antragstellende_Organisation_Foerderquote.path,
		value: calculateFoerderquoteData(allKostenpositionVonAntragsteller),
	});
	return result;
}
function calculateJahresAufteilung(application: any) {
	let result: any = [];
	const allKostenposition = get(application, P.Foerderantrag_Kostenpositions.path, []);

	const calculatedJahreaufteilung = calculateFinancials(allKostenposition);
	result.push(
		{
			path: P.Allgemein_Geplante_Projektausgaben.path,
			value: get(calculatedJahreaufteilung, 'gesamtAusgaben'),
		},
		{
			path: P.Allgemein_Beantragte_Zuwendung.path,
			value: get(calculatedJahreaufteilung, 'gesamtZuwendung'),
		},
		{ path: P.Bewilligung_Jahresaufteilung.path, value: get(calculatedJahreaufteilung, 'Jahrenaufteilung') }
	);
	return result;
}
function calculateGesamtFoerderquote(application: any) {
	let result: any = [];

	const allKostenPosition = get(application, P.Foerderantrag_Kostenpositions.path, []);

	// Förderquote für Antragsteller
	const allAusgabenAntragsteller_Arr = allKostenPosition.filter(
		(ele: any) =>
			get(ele, `${KP_P.Unternehmen.path}.id`) === get(getLocalstorageToken(), 'organisationId') &&
			get(ele, KP_P.Allgemein_Kostenposition.path) === 'Ausgabe'
	);

	const allEinnahmenAntragsteller_Arr = allKostenPosition.filter(
		(ele: any) =>
			get(ele, `${KP_P.Unternehmen.path}.id`) === get(getLocalstorageToken(), 'organisationId') &&
			get(ele, KP_P.Allgemein_Kostenposition.path) === 'Einnahme'
	);

	const ausgabenGesamtAntragsteller = allAusgabenAntragsteller_Arr.reduce((acc: any, ele: any) => {
		return acc + parseFloat(get(ele, KP_P.Allgemein_Geplante_Gesamtsumme.path, '0.0'));
	}, 0);
	const einnahmenGesamtAntragsteller = allEinnahmenAntragsteller_Arr.reduce((acc: any, ele: any) => {
		return acc + parseFloat(get(ele, KP_P.Allgemein_Geplante_Gesamtsumme.path, '0.0'));
	}, 0);
	const zuwendungGesamtAntragsteller = ausgabenGesamtAntragsteller - einnahmenGesamtAntragsteller;
	const foerderQuoteAntragsteller = ausgabenGesamtAntragsteller !== 0 ? (zuwendungGesamtAntragsteller / ausgabenGesamtAntragsteller) * 100 : 0;

	result.push({
		path: P.Orga_Foerderquote_Gesamt.path,
		value: !isNaN(foerderQuoteAntragsteller) ? foerderQuoteAntragsteller.toFixed(2) : 0,
	});

	// FörderQuote unabhängig von Antragsteller oder Parter
	// Gesamt aussicht
	const allAusgaben_Arr = allKostenPosition.filter((ele: any) => get(ele, KP_P.Allgemein_Kostenposition.path) === 'Ausgabe');
	const allEinnahme_Arr = allKostenPosition.filter((ele: any) => get(ele, KP_P.Allgemein_Kostenposition.path) === 'Einnahme');

	const ausgabenGesamt = allAusgaben_Arr.reduce((acc: any, ele: any) => {
		return acc + parseFloat(get(ele, KP_P.Allgemein_Geplante_Gesamtsumme.path, '0.0'));
	}, 0);
	const einnahmennGesamt = allEinnahme_Arr.reduce((acc: any, ele: any) => {
		return acc + parseFloat(get(ele, KP_P.Allgemein_Geplante_Gesamtsumme.path, '0.0'));
	}, 0);
	const zuwendungGesamt = ausgabenGesamt - einnahmennGesamt;
	const foerderQuoteGesamt = ausgabenGesamt !== 0 ? (zuwendungGesamt / ausgabenGesamt) * 100 : 0;

	result.push({
		path: P.Bewilligung_Foerderquote_Gesamt.path,
		value: !isNaN(foerderQuoteGesamt) ? foerderQuoteGesamt.toFixed(2) : 0,
	});
	return result;
}

/*
 ***************************************************************************************************************
 * ************************ HELPER FUNCTIONS *******************************************************************
 * *************************************************************************************************************
 */
function calculateAllgemeinKostenProJehrGesamtSumme(dataArray: any) {
	const total = dataArray.reduce((sum: any, item: any) => {
		// Convert the Zelle_2 value to a number and add it to the sum
		return sum + parseFloat(item.Zelle_2);
	}, 0);

	// Return the total formatted to 2 decimal places
	return total.toFixed(2);
}
// Helper function to ensure the array length matches projektDauer, filling with empty objects if necessary
const ensureArrayLength = (array: any[], length: number, projektJahrStart: number, filler: any) => {
	if (array.length > length) {
		return array.slice(0, length);
	} else {
		const newArray = array.map((item: any, index: number) => ({
			...item,
			Zelle_1: get(item, 'Zelle_1') !== undefined ? item.Zelle_1 : projektJahrStart + index,
		}));
		while (newArray.length < length) {
			newArray.push({
				...filler,
				Zelle_1: projektJahrStart + newArray.length,
			});
		}
		return newArray;
	}
};

function transformInvestitionsKostenElektroBusse(eachKosten: any, projektJahrStart: any, projektDauer: any) {
	const calculateBussePreisProJahr = (elektroBusseBlock: any) => {
		const dieselBusGrundPreis = get(elektroBusseBlock, 'Kalkulation_Der_Investit_0006792226_sse_Fahrzeug_Block_1_Zelle_2', 0);
		const dieselBusAusstattung = get(elektroBusseBlock, 'Kalkulation_Der_Investit_0006792227_sse_Fahrzeug_Block_1_Zelle_3', 0);
		const elektroBusGrundPreis = get(elektroBusseBlock, 'Kalkulation_Der_Investit_0006792242_sse_Fahrzeug_Block_2_Zelle_2', 0);
		const elektroBusAusstattung = get(elektroBusseBlock, 'Kalkulation_Der_Investit_0006792243_sse_Fahrzeug_Block_2_Zelle_3', 0);

		const diesenlBusFahrzeugpreis = parseFloat(dieselBusAusstattung) + parseFloat(dieselBusGrundPreis);
		const elektroBusFahrzeugpreis = parseFloat(elektroBusAusstattung) + parseFloat(elektroBusGrundPreis);
		const investitionsmehrausgaben = elektroBusFahrzeugpreis - diesenlBusFahrzeugpreis;

		const ProjektJahr_Block_1 = get(elektroBusseBlock, 'Projekt_Jahr', []);
		let gesamtAnzahlBusse = 0;
		let gesamtSumme = 0;

		// eslint-disable-next-line array-callback-return
		const ProjektJahrBlock = ProjektJahr_Block_1.map((item: any, index: number) => {
			const zelle3Value = item.Zelle_2 && investitionsmehrausgaben ? item.Zelle_2 * investitionsmehrausgaben : '0.0';
			const result = {
				Zelle_1: projektJahrStart + index,
				Zelle_2: item.Zelle_2,
				Zelle_3: zelle3Value,
			};
			if (item.id) set(result, 'id', item.id);
			return result;
		});

		// if (isArray(ProjektJahrBlock)) {
		gesamtAnzahlBusse = ProjektJahrBlock.reduce((sum: any, item: any) => sum + parseFloat(get(item, 'Zelle_2', '0')), 0).toFixed(2);
		gesamtSumme = ProjektJahrBlock.reduce((sum: any, item: any) => sum + parseFloat(get(item, 'Zelle_3', '0')), 0).toFixed(2);
		// }

		return {
			...elektroBusseBlock,
			Kalkulation_Der_Investit_0006792228_sse_Fahrzeug_Block_1_Zelle_4: diesenlBusFahrzeugpreis.toFixed(2),
			Kalkulation_Der_Investit_0006792244_sse_Fahrzeug_Block_2_Zelle_4: elektroBusFahrzeugpreis.toFixed(2),
			Kalkulation_Der_Investit_0185967294_sse_Investitionsmehrausgaben: investitionsmehrausgaben.toFixed(2),
			Zelle_2: !isNaN(gesamtAnzahlBusse) ? gesamtAnzahlBusse : 0,
			Zelle_3: !isNaN(gesamtSumme) ? gesamtSumme : 0,
			Projekt_Jahr: ensureArrayLength(ProjektJahrBlock, projektDauer, projektJahrStart, { Zelle_2: null, Zelle_3: null }),
		};
	};

	// Helper function to calculate Zelle_2 for Allgemein_Kosten_Pro_Jahr
	const calculateAllgemeinKostenProJahr = (investitionsProjektjahrBlock1: any) => {
		return investitionsProjektjahrBlock1.map((item: any, i: number) => {
			const Zelle2Value = item.Zelle_3 ? parseFloat(item.Zelle_3) : '0.00';
			const result = {
				Zelle_1: item.Zelle_1,
				Zelle_2: Zelle2Value,
			};
			if (get(eachKosten, `${KP_P.Allgemein_Kosten_Pro_Jahr.path}.${i}.id`))
				set(result, 'id', get(eachKosten, `${KP_P.Allgemein_Kosten_Pro_Jahr.path}.${i}.id`));
			return result;
		});
	};
	const calculatedElektorBusse = calculateBussePreisProJahr(
		get(eachKosten, KP_P.Kalkulation_Der_Investitionsmehrausgaben_Fuer_Elektrobusse.path, {})
	);
	const calculatedAllgemeinKostenProJahr = calculateAllgemeinKostenProJahr(calculatedElektorBusse.Projekt_Jahr);

	return {
		...eachKosten,
		attributes: {
			...eachKosten.attributes,
			[getFieldNamefromDataPath(KP_P.Allgemein_Kosten_Pro_Jahr.path)]: ensureArrayLength(
				calculatedAllgemeinKostenProJahr,
				projektDauer,
				projektJahrStart,
				{
					Zelle_2: '0.00',
				}
			),
			[getFieldNamefromDataPath(KP_P.Kalkulation_Der_Investitionsmehrausgaben_Fuer_Elektrobusse.path)]: calculatedElektorBusse,
			[getFieldNamefromDataPath(KP_P.Allgemein_Geplante_Gesamtsumme.path)]:
				calculateAllgemeinKostenProJehrGesamtSumme(calculatedAllgemeinKostenProJahr),
		},
	};
}
function transformInvestitionsKostenLadeInfrastruktur(eachKosten: any, projektJahrStart: number, projektDauer: number) {
	const kalkulierteAusgabe = get(
		eachKosten,
		KP_P.Kalkulation_Der_Ausgaben_Infrastruktur_Ladesaeulen_Elektrobusse.schema.attributes
			.Kalkulation_Der_Ausgaben_0183571662_robusse_Kalkulierte_Ausgaben.path,
		0
	);
	const anzahlKwLwistung = get(
		eachKosten,
		KP_P.Kalkulation_Der_Ausgaben_Infrastruktur_Ladesaeulen_Elektrobusse.schema.attributes
			.Kalkulation_Der_Ausgaben_0212753751_KW_Installierte_Ladeleistung.path,
		0
	);

	const AusgabenProKW = anzahlKwLwistung > 0 ? kalkulierteAusgabe / anzahlKwLwistung : 0;
	const projektbezogeneAusgabe = AusgabenProKW > 1000 ? anzahlKwLwistung * 1000 : kalkulierteAusgabe;

	const calculatedAllgemeinKostenProJahr = ensureArrayLength(
		get(eachKosten, KP_P.Allgemein_Kosten_Pro_Jahr.path, []),
		projektDauer,
		projektJahrStart,
		{ Zelle_2: null }
	);

	return {
		...eachKosten,
		attributes: {
			...eachKosten.attributes,
			// Kalkulation Block
			[getFieldNamefromDataPath(KP_P.Kalkulation_Der_Ausgaben_Infrastruktur_Ladesaeulen_Elektrobusse.path)]: {
				...get(eachKosten, KP_P.Kalkulation_Der_Ausgaben_Infrastruktur_Ladesaeulen_Elektrobusse.path),
				// Ausgaben pro kW Ladeleistung
				[getFieldNamefromDataPath(
					KP_P.Kalkulation_Der_Ausgaben_Infrastruktur_Ladesaeulen_Elektrobusse.schema.attributes
						.Kalkulation_Der_Ausgaben_0070636583_Ausgaben_Pro_KW_Ladeleistung.path
				)]: !isNaN(AusgabenProKW) ? AusgabenProKW.toFixed(2) : 0,
				// Projekbezogene Ausgaben
				[getFieldNamefromDataPath(
					KP_P.Kalkulation_Der_Ausgaben_Infrastruktur_Ladesaeulen_Elektrobusse.schema.attributes
						.Kalkulation_Der_Ausgaben_0119491950_usse_Projekbezogene_Ausgaben.path
				)]: !isNaN(projektbezogeneAusgabe) ? parseFloat(projektbezogeneAusgabe).toFixed(2) : 0,
			},
			// Allgemein Geplante Gesamtsumme
			[getFieldNamefromDataPath(KP_P.Allgemein_Geplante_Gesamtsumme.path)]:
				calculateAllgemeinKostenProJehrGesamtSumme(calculatedAllgemeinKostenProJahr),
			// Allgemein Kosten Pro Jahr Tabelle
			[getFieldNamefromDataPath(KP_P.Allgemein_Kosten_Pro_Jahr.path)]: calculatedAllgemeinKostenProJahr,
			// reset Other Block
			[getFieldNamefromDataPath(KP_P.Kalkulation_Der_Investitionsmehrausgaben_Fuer_Elektrobusse.path)]: {},
			[getFieldNamefromDataPath(KP_P.Kalkulation_Der_Ausgaben_Netzanschluss_Elektrobusse.path)]: {},
		},
	};
}
function transformInvestitionsKostenNetzanschluss(eachKosten: any, projektJahrStart: number, projektDauer: number) {
	const kalkulierteAusgabe = get(
		eachKosten,
		KP_P.Kalkulation_Der_Ausgaben_Netzanschluss_Elektrobusse.schema.attributes.Kalkulation_Der_Ausgaben_0055858862_robusse_Kalkulierte_Ausgaben
			.path,
		0
	);
	const anzahlStandOrte = get(
		eachKosten,
		KP_P.Kalkulation_Der_Ausgaben_Netzanschluss_Elektrobusse.schema.attributes.Kalkulation_Der_Ausgaben_0195029461_lektrobusse_Anzahl_Standorte
			.path,
		0
	);

	const AusgabenProStandOrt = anzahlStandOrte > 0 ? kalkulierteAusgabe / anzahlStandOrte : 0;
	const projektbezogeneAusgabe = AusgabenProStandOrt > 250000 ? anzahlStandOrte * 250000 : kalkulierteAusgabe;

	const calculatedAllgemeinKostenProJahr = ensureArrayLength(
		get(eachKosten, KP_P.Allgemein_Kosten_Pro_Jahr.path, []),
		projektDauer,
		projektJahrStart,
		{ Zelle_2: null }
	);

	return {
		...eachKosten,
		attributes: {
			...eachKosten.attributes,
			// Kalkulation Block
			[getFieldNamefromDataPath(KP_P.Kalkulation_Der_Ausgaben_Netzanschluss_Elektrobusse.path)]: {
				...get(eachKosten, KP_P.Kalkulation_Der_Ausgaben_Netzanschluss_Elektrobusse.path),
				// Ausgaben pro Standort
				[getFieldNamefromDataPath(
					KP_P.Kalkulation_Der_Ausgaben_Netzanschluss_Elektrobusse.schema.attributes
						.Kalkulation_Der_Ausgaben_0069253156_obusse_Ausgaben_Pro_Standort.path
				)]: !isNaN(AusgabenProStandOrt) ? AusgabenProStandOrt.toFixed(2) : 0,
				// Projekbezogene Ausgaben
				[getFieldNamefromDataPath(
					KP_P.Kalkulation_Der_Ausgaben_Netzanschluss_Elektrobusse.schema.attributes
						.Kalkulation_Der_Ausgaben_0054013598_usse_Projekbezogene_Ausgaben.path
				)]: !isNaN(projektbezogeneAusgabe) ? parseFloat(projektbezogeneAusgabe).toFixed(2) : 0,
			},
			// Allgemein Geplante Gesamtsumme
			[getFieldNamefromDataPath(KP_P.Allgemein_Geplante_Gesamtsumme.path)]:
				calculateAllgemeinKostenProJehrGesamtSumme(calculatedAllgemeinKostenProJahr),
			// Allgemein Kosten Pro Jahr Tabelle
			[getFieldNamefromDataPath(KP_P.Allgemein_Kosten_Pro_Jahr.path)]: calculatedAllgemeinKostenProJahr,
			// reset Other Block
			[getFieldNamefromDataPath(KP_P.Kalkulation_Der_Investitionsmehrausgaben_Fuer_Elektrobusse.path)]: {},
			[getFieldNamefromDataPath(KP_P.Kalkulation_Der_Ausgaben_Infrastruktur_Ladesaeulen_Elektrobusse.path)]: {},
		},
	};
}
function transformInvestitionsKostenH2(eachKosten: any, projektJahrStart: number, projektDauer: number) {
	const allgemeinKostenProJahrBlock = get(eachKosten, KP_P.Allgemein_Kosten_Pro_Jahr.path, []);

	const gesamtSumme = calculateAllgemeinKostenProJehrGesamtSumme(allgemeinKostenProJahrBlock);

	return {
		...eachKosten,
		attributes: {
			...eachKosten.attributes,
			// Allgemein Kosten Pro Jahr Tabelle
			[getFieldNamefromDataPath(KP_P.Allgemein_Kosten_Pro_Jahr.path)]: ensureArrayLength(
				allgemeinKostenProJahrBlock,
				projektDauer,
				projektJahrStart,
				{ Zelle_2: null }
			),
			// Allgemein Geplante Gesamtsumme
			[getFieldNamefromDataPath(KP_P.Allgemein_Geplante_Gesamtsumme.path)]: gesamtSumme,

			// reset Other Block
			[getFieldNamefromDataPath(KP_P.Kalkulation_Der_Investitionsmehrausgaben_Fuer_Elektrobusse.path)]: {},
			[getFieldNamefromDataPath(KP_P.Kalkulation_Der_Ausgaben_Infrastruktur_Ladesaeulen_Elektrobusse.path)]: {},
		},
	};
}

const calculateFoerderquoteData = (data: any[]) => {
	// Extract all unique years from the data
	const years = Array.from(new Set(data.flatMap((item) => get(item, KP_P.Allgemein_Kosten_Pro_Jahr.path, []).map((k: any) => k.Zelle_1))));

	// Calculate Foerderquote for each year
	const result = years.map((year) => {
		let sumAusgabe = 0;
		let sumEinnahme = 0;

		data.forEach((item) => {
			get(item, KP_P.Allgemein_Kosten_Pro_Jahr.path, []).forEach((kosten: any) => {
				if (kosten.Zelle_1 === year) {
					const value = parseFloat(kosten.Zelle_2);
					if (!isNaN(value)) {
						if (get(item, KP_P.Allgemein_Kostenposition.path) === 'Ausgabe') {
							sumAusgabe += value;
						} else if (get(item, KP_P.Allgemein_Kostenposition.path) === 'Einnahme') {
							sumEinnahme += value;
						}
					}
				}
			});
		});

		const foerderquote = sumAusgabe !== 0 ? ((sumAusgabe - sumEinnahme) / sumAusgabe) * 100 : 0;

		return {
			Projektjahr: year,
			Foerderquote_403741: foerderquote.toFixed(2), // Round to two decimal places
		};
	});

	return result;
};
function calculateFinancials(data: any) {
	const result: any = {};

	let gesamtAusgaben = 0;
	let gesamtEinnahme = 0;

	data.forEach((item: any) => {
		const { Allgemein_Kostenposition, Allgemein_Kosten_Pro_Jahr } = item.attributes;

		Allgemein_Kosten_Pro_Jahr.forEach((yearlyCost: any) => {
			const year = yearlyCost.Zelle_1;
			const amount = parseFloat(yearlyCost.Zelle_2) || 0;

			if (!result[year]) {
				result[year] = {
					Projektjahr: year,
					Ausgaben: 0,
					Eigen_45_Und_Drittmittel: 0,
				};
			}

			if (Allgemein_Kostenposition === 'Ausgabe') {
				result[year].Ausgaben += amount;
				gesamtAusgaben += amount;
			} else if (Allgemein_Kostenposition === 'Einnahme') {
				result[year].Eigen_45_Und_Drittmittel += amount;
				gesamtEinnahme += amount;
			}
		});
	});

	const Jahrenaufteilung = Object.values(result).map((item: any) => {
		const { Ausgaben, Eigen_45_Und_Drittmittel } = item;
		const Zuwendung = (Ausgaben || 0) - (Eigen_45_Und_Drittmittel || 0);
		const Foerderquote_403741 = Ausgaben > 0 ? (Zuwendung / Ausgaben) * 100 : 0;

		return {
			...item,
			Ausgaben: Ausgaben.toFixed(2),
			Eigen_45_Und_Drittmittel: Eigen_45_Und_Drittmittel.toFixed(2),
			Zuwendung: Zuwendung.toFixed(2),
			Foerderquote_403741: Foerderquote_403741.toFixed(2),
		};
	});

	const gesamtZuwendung = gesamtAusgaben - gesamtEinnahme;
	const gesamtFoerderQuote = gesamtAusgaben > 0 ? (gesamtZuwendung / gesamtAusgaben) * 100 : 0;

	return {
		gesamtAusgaben: !isNaN(gesamtAusgaben) ? gesamtAusgaben.toFixed(2) : 0,
		gesamtEinnahme: !isNaN(gesamtEinnahme) ? gesamtEinnahme.toFixed(2) : 0,
		gesamtZuwendung: !isNaN(gesamtZuwendung) ? gesamtZuwendung.toFixed(2) : 0,
		gesamtFoerderQuote: !isNaN(gesamtFoerderQuote) ? gesamtFoerderQuote.toFixed(2) : 0,
		Jahrenaufteilung,
	};
}
